<template functional>
  <a-menu-item v-if="!props.menu.children || props.menu.children.length === 0" :key="`menu-item-${props.menu.id}`">
    <router-link :to="props.menu.link" :target="props.menu.target === 2 ? '_blank' : ''">
      <a-icon v-if="props.menu.icon" :type="props.menu.icon" />
      <span>{{ props.menu.name }}</span>
    </router-link>
  </a-menu-item>

  <a-sub-menu v-else :key="`submenu-${props.menu.id}`">
    <template slot="title">
      <a-icon v-if="props.menu.icon" :type="props.menu.icon" />
      <span>{{ props.menu.name }}</span>
    </template>
    <template v-for="item in props.menu.children">
      <a-menu-item v-if="!item.children || item.children.length === 0" :key="`menu-item-${item.id}`">
        <router-link :to="item.link" :target="item.target === 2 ? '_blank' : ''">
          <a-icon v-if="item.icon" :type="item.icon" />
          <span>{{ item.name }}</span>
        </router-link>
      </a-menu-item>
      <sub-menu v-else :key="`submenu-${item.id}`" :menu="item" />
    </template>
  </a-sub-menu>
</template>

<script>
export default {
  props: {
    menu: { type: Object },
  },
}
</script>
